import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NotificationContainer } from 'react-notifications';

import Preloader from 'components/commons/Preloader';
import ScrollToTop from 'containers/ScrollToTop';
import HeaderContainer from 'containers/HeaderContainer';
import NavigationContainer from 'containers/NavigationContainer';
import ModalManager from 'containers/ModalManager';
import Whatsapp from 'components/commons/Whatsapp';
import Footer from 'components/main/Footer';
import Header from 'Header';
import CartPopup from 'components/commons/CartPopup';
import MercadoPagoInitializer from 'containers/MercadoPagoInitializer';
import ConstructionLanding from 'views/ConstructionLanding';
import { getStoreDesign } from 'constants/storeDesigns';
import { getCustomDesignClasses, getCustomDesignStyle } from 'constants/customDesign';

const colorPropType = PropTypes.oneOfType([
  PropTypes.shape(),
  PropTypes.string,
  PropTypes.number,
]);

const THEME_COLOR_FIELDS = [
  'color_prin',
  'color_sec',
  'color_text',
  'color_text_selected',
  'color_title',
  'color_nav2',
  'color_nav_text2',
  'color_price_text',
  'color_button',
  'color_button_text',
  'color1',
  'color2',
];

const hasThemeColor = (value) => {
  if (value === null || value === undefined || value === '') return false;
  if (typeof value === 'number') return value > 0;
  if (typeof value === 'string') return value.trim() !== '' && value !== '0';
  return true;
};

const hasAnyThemeColor = (client) => (
  THEME_COLOR_FIELDS.some((field) => hasThemeColor(client?.[field]))
);

const SiteShellContainer = ({ client, whatsapp }) => {
  const shouldShowConstruction = client && !hasAnyThemeColor(client);
  const storeDesign = getStoreDesign(client?.design);
  const designClass = client?.design !== undefined && client?.design !== null
    ? `design-${client.design}`
    : 'design-0';
  const marketClass = storeDesign ? `design-market-${storeDesign.market}` : '';
  const customDesignClass = getCustomDesignClasses(client);
  const customDesignStyle = getCustomDesignStyle(client);
  const shellClassName = `super-container ${designClass} ${marketClass} ${customDesignClass}`.trim();
  const customFontBody = customDesignStyle['--custom-font-body'];

  useEffect(() => {
    const shell = document.querySelector('.super-container');
    const nextFont = shell
      ? getComputedStyle(shell).getPropertyValue('--store-font-family').trim()
      : '';
    const previousFont = document.body.style.getPropertyValue('--store-font-family');

    if (nextFont) {
      document.body.style.setProperty('--store-font-family', nextFont);
    }

    return () => {
      if (previousFont) {
        document.body.style.setProperty('--store-font-family', previousFont);
      } else {
        document.body.style.removeProperty('--store-font-family');
      }
    };
  }, [shellClassName, customFontBody]);

  return (
    <div className={shellClassName} style={customDesignStyle}>
      <Header />
      <Preloader />
      <ScrollToTop />
      <NotificationContainer />
      {shouldShowConstruction ? (
        <ConstructionLanding client={client} whatsapp={whatsapp} />
      ) : (
        <>
          <HeaderContainer />
          <NavigationContainer />
          <MercadoPagoInitializer />
          <ModalManager />
          <Whatsapp />
          <CartPopup />
          <Footer />
          <div className="footer__spacer" />
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  client: state.app.client,
  whatsapp: state.app.whatsapp,
});

SiteShellContainer.defaultProps = {
  client: null,
  whatsapp: null,
};

SiteShellContainer.propTypes = {
  client: PropTypes.shape({
    color1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color_button: colorPropType,
    color_button_text: colorPropType,
    color_nav2: colorPropType,
    color_nav_text2: colorPropType,
    color_price_text: colorPropType,
    color_footer_background: colorPropType,
    color_footer_title: colorPropType,
    color_footer_text: colorPropType,
    color_footer_bottom: colorPropType,
    color_prin: colorPropType,
    color_sec: colorPropType,
    color_text: colorPropType,
    color_text_selected: colorPropType,
    color_title: colorPropType,
  }),
  whatsapp: PropTypes.shape({
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

export default connect(mapStateToProps)(SiteShellContainer);
